<template>
  <div>
    <CCol lg="12" style="padding-left: 0px; padding-right: 0px">
      <CCard>
        <h2>
          <CCardHeader style="font-size: 26px; color: black">
            <CRow>
              <CCol lg="12"> Delivery Option </CCol>
            </CRow>
          </CCardHeader>
        </h2>
        <CRow
          style="
            margin-left: 10px;
            margin-top: 10px;
            margin-bottom: 30px;
            margin-right: 10px;
          "
        >
          <CCol sm="6" md="6" lg="12">
            <h5>More Options to Delivery Products</h5>
            <h6>
              Customized Delivery Option for the Custmers. You can have multiple
              options. (Press "ENTER" for every new option)
            </h6>
            <vue-tags-input
              v-model="user.deliveryOption"
              :tags="user.deliveryOptions"
              placeholder="Delivery Options"
              @tags-changed="(newTags) => (user.deliveryOptions = newTags)"
            />
            <CButton
              block
              color="primary"
              style="
                margin: 0px auto 10px;
                margin-top: 10px;
                width: fit-content;
              "
              @click="update()"
            >
              Update
            </CButton>
          </CCol>
          <!-- <CCol lg="6">
          <vue-tags-input
            v-model="user.deliveryOption"
            :tags="user.deliveryOptions"
            placeholder="Delivery Options"
            @tags-changed="(newTags) => (user.deliveryOptions = newTags)"
          />
        </CCol> -->
        </CRow>
      </CCard>
    </CCol>
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader> Peyk </CCardHeader>
          <CCardBody>
            <CForm>
              <CInput
                autocomplete="id"
                label="Client Id"
                horizontal
                placeholder="Client ID"
                v-model="peyk_id"
              />
              <CInput
                autocomplete="secret"
                label="Client Secret"
                horizontal
                placeholder="Client Secret"
                v-model="peyk_secret"
              />
            </CForm>
          </CCardBody>
          <CCardFooter>
            <CButton
              type="submit"
              size="sm"
              color="primary"
              @click="peykUpdate()"
            >
              <CIcon name="cil-check-circle" /> Submit</CButton
            >
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <CModal
      title="Updated Successfully"
      size="sm"
      :show.sync="peykModal"
      :centered="true"
    >
      Your peyk details have been saved.
      <template #footer>
        <CButton @click="peykModal = false" color="success">Okay</CButton>
      </template>
    </CModal>
    <CModal
      title="Updated Successfully"
      size="sm"
      :show.sync="updated"
      :centered="true"
    >
      Your delivery details have been saved.
      <template #footer>
        <CButton @click="updated = false" color="success">Okay</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import firebase from "firebase";
import { cibCcStripe } from "@coreui/icons";
import VueTagsInput from "@johmun/vue-tags-input";
import vSelect from "vue-select";
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  stripe: cibCcStripe,
  data() {
    return {
      peyk_id: null,
      peyk_secret: null,
      peykModal: false,
      user: {
        deliveryOption: "",
        deliveryOptions: [],
      },
      updated: false,
    };
  },
  components: {
    VueTagsInput,
    vSelect,
  },
  methods: {
    peykUpdate() {
      const db = firebase.firestore();
      let temp;
      db.collection("users")
        .doc(firebase.auth().currentUser.phoneNumber)
        .update({
          peyk_id: this.peyk_id,
          peyk_secret: this.peyk_secret,
        })
        .then(() => {
          this.peykModal = true;
        });
    },
    getUserDetails() {
      const db = firebase.firestore();
      let temp;
      db.collection("users")
        .where("id", "==", firebase.auth().currentUser.uid)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.id = doc.id;
            temp = {
              peyk_id: doc.data().peyk_id,
              peyk_secret: doc.data().peyk_secret,
              deliveryOption: doc.data().deliveryOption,
            };
            this.peyk_id = temp.peyk_id;
            this.peyk_secret = temp.peyk_secret;
            this.user.deliveryOptions = temp.deliveryOption;
          });
        });
    },
    update() {
      const db = firebase.firestore();
      for (let [key, value] of Object.entries(this.user)) {
        if (key && !value) {
          this.user[key] = null;
        }
      }
      let deliveryOption = [];
      for (var key in this.user.deliveryOptions) {
        if (this.user.deliveryOptions.hasOwnProperty(key)) {
          let a = this.user.deliveryOptions[key];
          let text = a["text"];
          deliveryOption.push(text);
        }
      }
      db.collection("users")
        .doc(this.id)
        .update({
          deliveryOption: deliveryOption,
        })
        .then(() => {
          this.updated = true;
          this.user.deliveryOptions = deliveryOption;
        })
        .catch((error) => {
          console.log(error, "error");
        });
    },
  },
  created: function () {
    this.getUserDetails();
  },
};
</script>

<style>
</style>